import { rgba } from 'polished';
import React, { Component } from 'react';
import styled from 'styled-components';
import ErrorMessage from '@zocdoc-frontend-common/components-errormessage';
import { StandaloneLink } from '@zocdoc-mezzanine/components-link';
import { red80, slate40, white } from '@zocdoc-mezzanine/foundations-colors';

export type AddPhoneBoxProps = {
    hasError: boolean;
    onClick: () => void;
};

/**
 * @param {boolean} hasError
 * @param {function(): void} onClick
 * @returns {JSX.Element}
 * @constructor
 */
export class AddPhoneBox extends Component<AddPhoneBoxProps> {
    maybeRenderInvalidMessage(hasError: boolean) {
        if (hasError) {
            return (
                <ErrorMessage data-test="add-phone-error">
                    Please add your phone number.
                </ErrorMessage>
            );
        }
    }

    render() {
        const { hasError, onClick } = this.props;

        function standAloneOnClick(e: React.MouseEvent<HTMLButtonElement>) {
            e.stopPropagation();
            onClick();
        }

        return (
            <Container>
                <AddPhoneNumber
                    data-test="add-phone-number"
                    hasError={hasError}
                    onClick={onClick}
                    role="button"
                >
                    <StandaloneLink
                        data-test="add-phone-number-link"
                        onClick={standAloneOnClick}
                    >
                        Add phone number
                    </StandaloneLink>
                </AddPhoneNumber>
                {this.maybeRenderInvalidMessage(hasError)}
            </Container>
        );
    }
}

const Container = styled.div`
    position: relative;
`;

const AddPhoneNumber = styled.div<{ hasError: boolean }>`
    border: solid 1px ${(p) => (p.hasError ? red80 : rgba(slate40, 0.5))};
    background-color: ${white};
    box-sizing: content-box;
    height: 16px;
    padding: 16px;
    cursor: pointer;
`;
